import { render, staticRenderFns } from "./comisionesCondiciones.vue?vue&type=template&id=458bc870&scoped=true&"
import script from "./comisionesCondiciones.vue?vue&type=script&lang=js&"
export * from "./comisionesCondiciones.vue?vue&type=script&lang=js&"
import style0 from "./comisionesCondiciones.vue?vue&type=style&index=0&id=458bc870&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458bc870",
  null
  
)

export default component.exports